const getters = {
  isLoadingFinishMyDesign(state) {
    return state.isLoadingFinishMyDesign;
  }
};

export default getters;
